export const quotes = [
  {
    id: 1,
    text: "A smile is a curve that sets everything straight.",
    author: "Phyllis Diller",
    icon: "😊"
  },
  {
    id: 2,
    text: "Every smile deserves expert dental care.",
    author: "Olive Dental Clinic",
    icon: "✨"
  },
  {
    id: 3,
    text: "Healthy smiles begin with healthy habits.",
    author: "Olive Dental Clinic",
    icon: "🦷"
  },
  {
    id: 4,
    text: "Committed to creating healthy,confident smiles.",
    author: "Olive Dental Clinic",
    icon: "💚"
  }
];

// ============================================================
// HELPER FUNCTIONS
// ============================================================

// Get all quotes
export const getAllQuotes = () => quotes;

// Get quote by ID
export const getQuoteById = (id) =>
  quotes.find((quote) => quote.id === id);

// Get random quote
export const getRandomQuote = () =>
  quotes[Math.floor(Math.random() * quotes.length)];

// Get quote by author
export const getQuotesByAuthor = (author) =>
  quotes.filter((quote) => quote.author === author);

// Get all authors
export const getAllQuoteAuthors = () => {
  const authors = quotes.map((quote) => quote.author);
  return [...new Set(authors)];
};